import { DOMUtils } from '../../../../utils/dom'
import { AbstractWidgetAdapter, IWidgetAdapter } from '../../../widgets/adapters/adapter'

export class Origami extends AbstractWidgetAdapter implements IWidgetAdapter {
    public static DOM = {
        attrs: {
            adSize: 'data-ad-size',
            partnerId: 'data-partner-id'
        }
    }

    public constructor(public el: Element, public adLight = false) {
        super(el, adLight)
    }

    /**
     * Load 3rd party javascript with widget data
     */
    public loadData(): void {
        const adSize = this.el.getAttribute(Origami.DOM.attrs.adSize)
        const partnerId = this.el.getAttribute(Origami.DOM.attrs.partnerId)
        const scriptSource = 'https://origami.secure.ownlocal.com/origami-widget.js'

        // create element with id
        this.el.id = 'origami-ad-container'

        // only load the script if there is a partner ID to load
        if (partnerId) {
            const attributes = [{
                key: 'id',
                value: 'origami-ad-widget'
            }, {
                key: 'data-partner-id',
                value: partnerId
            }]

            if (adSize) {
                attributes.push({
                    key: 'data-ad-size',
                    value: adSize
                })
            }

            DOMUtils.loadScript(scriptSource, attributes)
        }
    }
}
